import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = { 
    url: String,
    interval: { type: Number, default: 2000 },
    collectorId: String
  }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
    
    this.intervalId = setInterval(() => {
      this.checkStatus()
    }, this.intervalValue)
    this.element.dataset.hostedCollectorStatusPolling = "active"
  }

  stopPolling() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
    this.element.dataset.hostedCollectorStatusPolling = "stopped"
  }

  async checkStatus() {
    try {
      const response = await fetch(this.urlValue, {
        method: "GET",
        credentials: "include",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.getElementsByName("csrf-token")[0]?.content
        }
      })

      if (response.ok) {
        const data = await response.json()
        this.updateStatus(data.status, data.status_class)
        
        // Stop polling if the status is final (provisioned, deprovisioned, or failed)
        if (["provisioned", "deprovisioned", "failed"].includes(data.status)) {
          this.stopPolling()
        }
      }
    } catch (error) {
      console.error("Error checking hosted collector status:", error)
    }
  }

  updateStatus(newStatus, statusClass) {
    this.statusTargets.forEach(target => {
      // Remove existing status classes
      target.className = target.className.replace(/c-pill c-pill--\w+/g, "").trim()
      
      if (statusClass) {
        target.className += ` ${statusClass}`
      }
      
      target.textContent = newStatus
    })

    // Fade out the row if status is deprovisioned. The 1s delay is an
    // informational pause so the user sees the final status before the row
    // leaves; only the opacity fade itself is skipped for reduced motion (see
    // fadeOutRow).
    if (newStatus === "deprovisioned") {
      setTimeout(() => {
        this.fadeOutRow()
      }, 1000)
    }
  }

  prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }

  fadeOutRow() {
    const row = this.element

    // Honor reduced motion: remove the row immediately with no fade transition.
    if (this.prefersReducedMotion()) {
      row.remove()
      return
    }

    row.style.transition = "opacity 0.5s ease-out"
    row.style.opacity = "0"

    // Remove the row after fade animation completes
    setTimeout(() => {
      row.remove()
    }, 500)
  }
}
